import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { imageSet } from '../../../helper/Images';

const Recommended = ({ recommendations, onSubmit, onSelect }) => (
  <Fragment>
    {recommendations.length > 1 && (
      <div className="recommendation-title">
        <FormattedMessage
          id="recommended.option"
          values={{ count: `${recommendations.length}` }}
          defaultMessage="Please select an option to proceed"
        />
      </div>
    )}
    <div
      className={`result-recommendation ${
        recommendations.length > 1 ? 'result-recommendation--multiple' : ''
      }`}
    >
      {recommendations.map((recommendation, index) => (
        <label key={recommendation.key} className="recommendation-item">
          <img className="img-responsive" src={imageSet[recommendation.img]} />
          <input
            type="radio"
            name="recommendation"
            value={recommendation.key}
            onChange={(event) => onSelect(event.target.value)}
            defaultChecked={index === 0}
          />
        </label>
      ))}
      <div className="quiz-submit">
        <button
          className="btn btn-color"
          onClick={() => onSubmit(recommendations)}
        >
          <FormattedMessage id="dba.submit" defaultMessage="Done" />
        </button>
      </div>
    </div>
  </Fragment>
);

export default Recommended;
